import { render, staticRenderFns } from "./CatalogueSettingsDashboard.vue?vue&type=template&id=e3cebdb8&"
import script from "./CatalogueSettingsDashboard.vue?vue&type=script&lang=ts&"
export * from "./CatalogueSettingsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports